import type { CloudConfig } from '../../../../../common/constants/filters/cloud-config/types';
import { allOpportunityStatusFilterValueKeys } from '../../../../../common/constants/filters/opportunity-status-filter';
import type { FetchedSelectFilterOption } from '../../../../../common/constants/filters/select-filter/types';

import { opportunityStatusLabels } from './messages';

export const getAllOpportunityStatusOptions = (
	config: CloudConfig,
): FetchedSelectFilterOption[] => {
	const allOption: FetchedSelectFilterOption = {
		value: 'all',
		trackingKey: 'all',
		queryParamValue: 'all',
		isDefault: true,
		label: config.intl?.formatMessage(opportunityStatusLabels['all']) ?? '',
		product: config.product,
	};

	const opportunityStatusOptions: FetchedSelectFilterOption[] =
		allOpportunityStatusFilterValueKeys.map((key) => ({
			value: key,
			trackingKey: key,
			queryParamValue: key,
			isDefault: false,
			label: config.intl?.formatMessage(opportunityStatusLabels[key]) ?? '',
			product: config.product,
		}));

	return [allOption, ...opportunityStatusOptions];
};
